import { formatDate } from '@/utils/datetime';
import { sub } from 'date-fns';

export default [
	{
		path: '/transactions',
		component: () =>
			import(
				'@/sections/transactions/summary/global-transactions-page.vue'
			),
		props: route => ({
			transactionId: route.query.transactionId,
			correlationId: route.query.correlationId,
			logEntrytransactionTypes:
				route.query.logEntrytransactionTypes || null,
			search: route.query.search,
			direction: route.query.direction,
			customers: route.query.customers
				? Array.isArray(route.query.customers)
					? route.query.customers
					: [route.query.customers]
				: undefined,
			healths: route.query.healths
				? Array.isArray(route.query.healths)
					? route.query.healths
					: [route.query.healths]
				: undefined,
			apiTypes: route.query.apiTypes
				? Array.isArray(route.query.apiTypes)
					? route.query.apiTypes
					: [route.query.apiTypes]
				: undefined,
			oemManufacturer: route.query.oemManufacturer,
			oemMethod: route.query.oemMethod,
			oemIntegrationName: route.query.oemIntegrationName, //TODO: rename when we add oem as an option
			otherSource: route.query.otherSource,
			requestType: route.query.requestType,
			isDMSIS: route.query.isDMSIS,
			minDatetime:
				route.query.minDatetime ||
				formatDate(new Date(sub(new Date(), { weeks: 1 }))),
			maxDatetime: route.query.maxDatetime || formatDate(new Date()),
			transactionMethod: route.query.transactionMethod,
			integrationCodes: route.query.integrationCodes
				? Array.isArray(route.query.integrationCodes)
					? route.query.integrationCodes
					: [route.query.integrationCodes]
				: [],
			primaryIntegrationVendorId:
				parseInt(route.query.primaryIntegrationVendorId) || 0,
			orderBy: route.query.orderBy || 'timestamp',
			orderDirection: route.query.orderDirection || 'desc',
			recordStart: parseInt(route.query.recordStart) || 1,
			maxCount: parseInt(route.query.maxCount) || 100
		}),
		meta: {
			permissions: ['transactions.read']
		}
	},
	{
		name: 'global-transactions-settings',
		path: '/transactions/:transactionId/:health',
		props: route => ({
			transactionId: route.params.transactionId,
			health: route.params.health
		}),
		component: () =>
			import(
				/* webpackChunkName: "viewReport" */ '@/sections/transactions/settings/global-transactions-details.vue'
			),
		meta: {
			permissions: ['transactions.read']
		}
	},
	{
		path: '/transactions/audit',
		component: () =>
			import('@/sections/transactions/audit/transaction-audit.vue'),
		props: route => ({
			search: route.query.search,
			userId: route.query.userId,
			minDatetime:
				route.query.minDatetime ||
				formatDate(new Date(sub(new Date(), { weeks: 1 }))),
			maxDatetime: route.query.maxDatetime || formatDate(new Date()),
			orderBy: route.query.orderBy || 'timestamp',
			orderDirection: route.query.orderDirection || 'desc',
			page: parseInt(route.query.page) || 1,
			countPerPage: parseInt(route.query.countPerPage) || 10
		}),
		meta: {
			permissions: ['transactions.read']
		}
	}
];
